<script lang="ts" setup>
import { UModalConfirm } from "#components";

const { t } = useI18n();
const modal = useModal();
const toolsStore = useToolsStore();
const telestrationStore = useTelestrationStore();
const shapesStore = useShapesStore();
const [minimized, toggleMinimized] = useToggle(false);

// Handle exit with confirmation
const handleExit = async () => {
  // Check if there are unsaved changes using shapes history
  if (shapesStore.historyState.canUndo) {
    if (document.fullscreenElement) {
      await document.exitFullscreen();
    }
    modal.open(UModalConfirm, {
      heading: t("pages.playlists.telestrations.telestration_exit_confirm"),
      icon: "telestration",
      variant: "delete",
      description: t("pages.playlists.telestrations.telestration_exit_heading"),
      confirmFn: () => telestrationStore.exitTelestrationMode(),
      confirmLabel: t("labels.exit"),
      cancelLabel: t("labels.cancel"),
    });
  }
  else {
    telestrationStore.exitTelestrationMode();
  }
};
const handleToggleFullscreen = () => {
  telestrationStore.toggleFullscreenInTelestration();
};
</script>

<template>
  <div
    v-if="minimized"
    class="absolute inset-x-2 bottom-2 z-10 flex gap-2 text-white"
  >
    <div class="flex rounded bg-black/[0.72] p-2 backdrop-blur-sm">
      <TButton :tooltip="t('labels.show')" :icon="{ name: 'chevron-right', class: 'h-3' }" @click="toggleMinimized(false)" />
    </div>
  </div>
  <div v-else class="absolute inset-x-2 bottom-2 z-10 flex gap-2 overflow-auto text-white">
    <div
      class="flex grow justify-between gap-6 rounded bg-black/[0.72] p-2 backdrop-blur-sm"
    >
      <div class="flex items-start">
        <div class="flex items-start gap-2">
          <TButtonTool
            v-for="tool in toolsStore.availableTools"
            :key="tool"
            :tool="tool"
          />
        </div>
        <div class="flex size-8 items-center justify-center">
          <UDivider vertical class="!h-6 w-8" darker />
        </div>
        <div class="flex items-start gap-2">
          <TButtonUndoRedo />
        </div>
        <div class="flex size-8 items-center justify-center">
          <UDivider vertical class="!h-6 w-8" darker />
        </div>
        <div class="flex h-full items-center gap-2">
          <TButtonNextPrevTelestration />
        </div>
      </div>

      <div class="flex w-max gap-3">
        <TButtonClearAll />
        <TButtonSave />
      </div>
    </div>

    <div class="flex rounded bg-black/[0.72] p-2 backdrop-blur-sm">
      <TButton
        :tooltip="t('labels.exit')"
        icon="exit"
        class="hover:bg-blue-500"
        @click="handleExit"
      />
      <TButton
        :tooltip="t('labels.hide')"
        :icon="{ name: 'chevron-left', class: 'h-3' }"
        class="hover:bg-blue-500"
        @click="toggleMinimized(true)"
      />
    </div>
    <div class="flex rounded bg-black/[0.72] p-2 backdrop-blur-sm">
      <TButton
        :icon="{ name: telestrationStore.isFullscreen ? 'collapse' : 'fullscreen-expand', class: 'h-4' }"
        class="hover:bg-blue-500"
        @click="handleToggleFullscreen"
      />
    </div>
  </div>
</template>
